var React = require('react');

function ArrowLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconfinder_icon-arrow-up-c_211624","d":"M119.343,83.709l3.563-3.4a1.1,1.1,0,0,1,1.52,0l3.577,3.4a1,1,0,0,1,0,1.466,1.122,1.122,0,0,1-1.534,0l-1.71-1.632v7.364a1.087,1.087,0,0,1-2.172,0V83.543l-1.71,1.636a1.122,1.122,0,0,1-1.534,0A1.007,1.007,0,0,1,119.343,83.709Z","transform":"translate(91.945 -119.025) rotate(90)","fill":"#ed1c24"}));
}

ArrowLink.defaultProps = {"width":"11.945","height":"9.296","viewBox":"0 0 11.945 9.296"};

module.exports = ArrowLink;

ArrowLink.default = ArrowLink;
